import TRANSFORMS from '../constants/transforms'

export default function getTransform (ref) {
  return TRANSFORMS[ref]
}
